module.exports = __webpack_public_path__ + "static/mobile-mock-web-d213534374e426078ef6b440646bbc5b.svg";